const popupLotProps = () => ({
    isFidelite: {
      type: Boolean,
      required: false,
      default: false
    },
    totalProduct: {
      type: Number,
      required: false,
      default: 0
    },
    remainProduct: {
      type: Number,
      required: false,
      default: 0
    },
    inCart: {
      type: Number,
      required: false,
    }
})

export {
  popupLotProps
}